import { render } from "./Game.vue?vue&type=template&id=52f077f2"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=52f077f2&lang=css"

import exportComponent from "E:\\Code\\Phaser3\\MillionaireGame\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__